import { render, staticRenderFns } from "./vacancy_details.vue?vue&type=template&id=5d514390&scoped=true&"
import script from "./vacancy_details.vue?vue&type=script&lang=js&"
export * from "./vacancy_details.vue?vue&type=script&lang=js&"
import style0 from "./vacancy_details.vue?vue&type=style&index=0&id=5d514390&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d514390",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d514390')) {
      api.createRecord('5d514390', component.options)
    } else {
      api.reload('5d514390', component.options)
    }
    module.hot.accept("./vacancy_details.vue?vue&type=template&id=5d514390&scoped=true&", function () {
      api.rerender('5d514390', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/vacancy_details.vue"
export default component.exports